var _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8277",
    "data-name": "Group 8277",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 54,
    viewBox: "0 0 163 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M213.26,461.321a7.252,7.252,0,0,1-7.2,7.3H57.466a7.253,7.253,0,0,1-7.206-7.3v-39.4a7.253,7.253,0,0,1,7.206-7.3h148.59a7.252,7.252,0,0,1,7.2,7.3Z",
    transform: "translate(-50.26 -414.619)",
    fill: "#1a1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M104.071,443.232H90.778a2.91,2.91,0,0,0-2.885,2.935v29.966a2.911,2.911,0,0,0,2.885,2.936h13.293a2.912,2.912,0,0,0,2.886-2.936V446.167A2.911,2.911,0,0,0,104.071,443.232Zm-6.646,33.683a1.955,1.955,0,1,1,1.922-1.956A1.938,1.938,0,0,1,97.424,476.915Zm7.266-4.863H90.158v-22.1H104.69Z",
    transform: "translate(-75.886 -434.103)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    "data-name": "Group 8264",
    transform: "translate(39.918 8.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M177.823,448.3l-.808,2.447h-1.039l2.643-7.781h1.212l2.655,7.781h-1.074l-.831-2.447Zm2.551-.785-.773-2.24c-.162-.509-.277-.97-.393-1.42h-.034c-.1.45-.231.935-.381,1.408l-.762,2.252Z",
    transform: "translate(-175.976 -442.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M197.323,449.842l1.1,3.129c.185.519.335.981.451,1.442h.034c.127-.461.288-.924.473-1.442l1.085-3.129h1.062l-2.194,5.587h-.97l-2.123-5.587Z",
    transform: "translate(-189.774 -447.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M218.123,453.82a9.369,9.369,0,0,0,.081,1.339h-.912l-.093-.7h-.034a2.062,2.062,0,0,1-1.709.831,1.591,1.591,0,0,1-1.708-1.6c0-1.352,1.2-2.09,3.359-2.078v-.116a1.146,1.146,0,0,0-1.269-1.292,2.691,2.691,0,0,0-1.466.415l-.232-.682a3.63,3.63,0,0,1,1.847-.484c1.721,0,2.135,1.166,2.135,2.286Zm-.993-1.513c-1.109-.023-2.366.173-2.366,1.259a.89.89,0,0,0,.945.97,1.412,1.412,0,0,0,1.374-.935,1.053,1.053,0,0,0,.046-.324Z",
    transform: "translate(-201.697 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M232.541,443.84a.652.652,0,0,1,.024-1.3.624.624,0,0,1,.647.646.636.636,0,0,1-.658.658Zm-.484,6.614v-5.587h1.016v5.587Z",
    transform: "translate(-214.062 -442.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M240.663,441.667h1.016v8.2h-1.016Z",
    transform: "translate(-220.024 -441.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M251.946,453.82a9.375,9.375,0,0,0,.081,1.339h-.913l-.092-.7h-.034a2.064,2.064,0,0,1-1.709.831,1.592,1.592,0,0,1-1.708-1.6c0-1.352,1.2-2.09,3.36-2.078v-.116a1.147,1.147,0,0,0-1.271-1.292,2.684,2.684,0,0,0-1.465.415l-.232-.682a3.628,3.628,0,0,1,1.847-.484c1.72,0,2.135,1.166,2.135,2.286Zm-.993-1.513c-1.108-.023-2.367.173-2.367,1.259a.89.89,0,0,0,.947.97,1.411,1.411,0,0,0,1.374-.935,1.033,1.033,0,0,0,.046-.324Z",
    transform: "translate(-224.728 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M266.1,441.667h1.016v3.5h.024a2.072,2.072,0,0,1,1.9-1.016c1.386,0,2.356,1.155,2.356,2.84,0,2.008-1.27,3-2.516,3a2,2,0,0,1-1.87-1.051h-.025l-.057.924h-.876c.034-.382.045-.946.045-1.443Zm1.016,5.957a1.827,1.827,0,0,0,.036.369,1.577,1.577,0,0,0,1.523,1.189c1.074,0,1.7-.866,1.7-2.148,0-1.131-.577-2.088-1.662-2.088a1.686,1.686,0,0,0-1.594,1.673Z",
    transform: "translate(-237.318 -441.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M286.605,441.667h1.016v8.2h-1.016Z",
    transform: "translate(-251.308 -441.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M294.6,452.513a1.781,1.781,0,0,0,1.9,1.939,3.854,3.854,0,0,0,1.547-.277l.184.715a4.543,4.543,0,0,1-1.87.358,2.606,2.606,0,0,1-2.747-2.816c0-1.7,1-3.025,2.633-3.025a2.358,2.358,0,0,1,2.3,2.631,2.629,2.629,0,0,1-.035.486Zm2.967-.727a1.451,1.451,0,0,0-1.4-1.652,1.676,1.676,0,0,0-1.558,1.652Z",
    transform: "translate(-256.086 -446.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M321.731,455.285a2.663,2.663,0,0,1-2.678-2.874,2.735,2.735,0,0,1,2.77-2.967,2.642,2.642,0,0,1,2.689,2.863,2.738,2.738,0,0,1-2.77,2.978Zm.034-.762c.97,0,1.7-.912,1.7-2.182,0-.946-.472-2.136-1.673-2.136s-1.708,1.108-1.708,2.171c0,1.224.692,2.147,1.674,2.147Z",
    transform: "translate(-273.403 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M339.9,451.084c0-.59-.013-1.051-.048-1.513h.9l.057.912h.023a2.071,2.071,0,0,1,1.846-1.039c.773,0,1.976.462,1.976,2.378v3.336h-1.017v-3.221c0-.9-.334-1.662-1.293-1.662a1.465,1.465,0,0,0-1.362,1.039,1.521,1.521,0,0,0-.069.474v3.37H339.9Z",
    transform: "translate(-287.565 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M367.253,445.647v1.338h1.453v.773h-1.453v3.013c0,.692.2,1.085.761,1.085a1.89,1.89,0,0,0,.59-.069l.045.773a2.76,2.76,0,0,1-.9.139,1.453,1.453,0,0,1-1.1-.426,2.193,2.193,0,0,1-.392-1.467v-3.047h-.865v-.773h.865v-1.027Z",
    transform: "translate(-304.958 -444.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M379.176,441.667h1.016v3.486h.023a1.8,1.8,0,0,1,.728-.715,1.975,1.975,0,0,1,1.04-.289c.749,0,1.949.462,1.949,2.39v3.324h-1.015v-3.208c0-.912-.335-1.663-1.293-1.663a1.47,1.47,0,0,0-1.361,1.016,1.224,1.224,0,0,0-.07.485v3.37h-1.016Z",
    transform: "translate(-314.343 -441.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M398.786,452.513a1.781,1.781,0,0,0,1.9,1.939,3.862,3.862,0,0,0,1.548-.277l.184.715a4.551,4.551,0,0,1-1.871.358,2.606,2.606,0,0,1-2.747-2.816c0-1.7,1-3.025,2.632-3.025a2.359,2.359,0,0,1,2.3,2.631,2.6,2.6,0,0,1-.035.486Zm2.967-.727a1.452,1.452,0,0,0-1.4-1.652,1.675,1.675,0,0,0-1.559,1.652Z",
    transform: "translate(-327.028 -446.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M424.667,443.84a.652.652,0,0,1,.023-1.3.624.624,0,0,1,.646.646.636.636,0,0,1-.659.658Zm-.486,6.614v-5.587H425.2v5.587Z",
    transform: "translate(-344.886 -442.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M432.894,442.948a10.444,10.444,0,0,1,1.928-.161,3.187,3.187,0,0,1,2.18.647,2.1,2.1,0,0,1,.694,1.627,2.245,2.245,0,0,1-.613,1.662,3.219,3.219,0,0,1-2.377.854,3.532,3.532,0,0,1-.808-.068v3.116h-1Zm1,3.74a3.424,3.424,0,0,0,.831.081c1.223,0,1.951-.6,1.951-1.651s-.727-1.535-1.835-1.535a5,5,0,0,0-.947.081Z",
    transform: "translate(-350.921 -442.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M451.672,441.667h1.016v3.486h.023a1.8,1.8,0,0,1,.727-.715,1.981,1.981,0,0,1,1.039-.289c.75,0,1.95.462,1.95,2.39v3.324h-1.015v-3.208c0-.912-.335-1.663-1.293-1.663a1.473,1.473,0,0,0-1.362,1.016,1.231,1.231,0,0,0-.069.485v3.37h-1.016Z",
    transform: "translate(-363.708 -441.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M472.981,455.285a2.663,2.663,0,0,1-2.678-2.874,2.735,2.735,0,0,1,2.771-2.967,2.642,2.642,0,0,1,2.688,2.863,2.737,2.737,0,0,1-2.769,2.978Zm.036-.762c.968,0,1.7-.912,1.7-2.182,0-.946-.473-2.136-1.674-2.136s-1.709,1.108-1.709,2.171c0,1.224.692,2.147,1.674,2.147Z",
    transform: "translate(-376.395 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M491.151,451.084c0-.59-.012-1.051-.046-1.513h.9l.057.912h.024a2.071,2.071,0,0,1,1.846-1.039c.773,0,1.973.462,1.973,2.378v3.336h-1.014v-3.221c0-.9-.335-1.662-1.294-1.662a1.465,1.465,0,0,0-1.361,1.039,1.5,1.5,0,0,0-.071.474v3.37h-1.015Z",
    transform: "translate(-390.56 -446.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M510.86,452.513a1.782,1.782,0,0,0,1.905,1.939,3.849,3.849,0,0,0,1.546-.277l.185.715a4.554,4.554,0,0,1-1.87.358,2.606,2.606,0,0,1-2.747-2.816c0-1.7,1-3.025,2.632-3.025a2.358,2.358,0,0,1,2.3,2.631,2.639,2.639,0,0,1-.034.486Zm2.967-.727a1.451,1.451,0,0,0-1.4-1.652,1.675,1.675,0,0,0-1.559,1.652Z",
    transform: "translate(-403.344 -446.938)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8265",
    "data-name": "Group 8265",
    transform: "translate(39.703 22.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M182.146,483.87,175.3,504.017h3.134l2.044-6.186h6.627l2.1,6.186h3.221l-6.874-20.147Zm1.624,3.313c.231.9.481,1.833.8,2.842l1.844,5.342h-5.249l1.819-5.376C183.262,489.118,183.525,488.176,183.77,487.183Z",
    transform: "translate(-175.302 -483.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M240.187,500.239a5.7,5.7,0,0,0-4.846,2.324l-.122-2h-2.788l.017.257c.082,1.248.117,2.622.117,4.6V520.94h3.047v-7.247a5.353,5.353,0,0,0,4.167,1.791,6.285,6.285,0,0,0,4.619-1.964,8.33,8.33,0,0,0,2.04-5.863,8.107,8.107,0,0,0-1.771-5.353A5.8,5.8,0,0,0,240.187,500.239Zm-.759,2.523c2.717,0,3.933,2.517,3.933,5.011,0,3.218-1.551,5.216-4.049,5.216a3.7,3.7,0,0,1-3.591-2.828,3.9,3.9,0,0,1-.109-.987v-2.451a4.556,4.556,0,0,1,.1-.752c.015-.084.031-.167.044-.248A3.86,3.86,0,0,1,239.428,502.762Z",
    transform: "translate(-214.204 -494.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M289.383,500.239a5.7,5.7,0,0,0-4.846,2.324l-.121-2h-2.788l.016.257c.082,1.249.117,2.622.117,4.6V520.94h3.049v-7.247a5.348,5.348,0,0,0,4.165,1.791,6.291,6.291,0,0,0,4.621-1.964,8.337,8.337,0,0,0,2.038-5.863,8.11,8.11,0,0,0-1.771-5.353A5.8,5.8,0,0,0,289.383,500.239Zm-.758,2.523c2.716,0,3.932,2.517,3.932,5.011,0,3.218-1.552,5.216-4.049,5.216a3.7,3.7,0,0,1-3.591-2.828,3.906,3.906,0,0,1-.107-.987v-2.451a4.4,4.4,0,0,1,.1-.755c.015-.082.03-.164.044-.245A3.858,3.858,0,0,1,288.625,502.762Z",
    transform: "translate(-247.704 -494.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M352.078,491.721c-2.845-1.1-3.756-1.968-3.756-3.569,0-1.348,1.071-2.707,3.465-2.707a6.925,6.925,0,0,1,3.578.9l.259.16.86-2.544-.17-.1a8.831,8.831,0,0,0-4.439-1c-3.887,0-6.6,2.3-6.6,5.58,0,2.649,1.7,4.5,5.351,5.827,2.586.967,3.549,1.958,3.549,3.655,0,1.922-1.485,3.115-3.874,3.115a8.344,8.344,0,0,1-4.393-1.246l-.264-.17-.818,2.6.15.1a10.437,10.437,0,0,0,5.151,1.324c5.239,0,7.1-3.194,7.1-5.93C357.22,494.9,355.731,493.162,352.078,491.721Z",
    transform: "translate(-290.735 -482.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M389.826,490.365l-2.99.939v2.532h-2.188v2.436h2.188v7.463a5.7,5.7,0,0,0,1.055,3.867,3.909,3.909,0,0,0,2.949,1.158,7.158,7.158,0,0,0,2.356-.364l.171-.06-.146-2.441-.292.09a4.6,4.6,0,0,1-1.418.164c-1.181,0-1.686-.748-1.686-2.5v-7.374H393.5v-2.436h-3.677Z",
    transform: "translate(-317.854 -487.971)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M420.618,500.239c-4.265,0-7.243,3.183-7.243,7.739,0,4.42,2.882,7.506,7.009,7.506h.029c3.489,0,7.243-2.431,7.243-7.768a7.7,7.7,0,0,0-1.942-5.392A6.782,6.782,0,0,0,420.618,500.239Zm-.088,2.406c2.742,0,3.99,2.673,3.99,5.158,0,3.056-1.7,5.274-4.048,5.274h-.029c-2.312,0-3.99-2.181-3.99-5.186C416.453,505.28,417.714,502.645,420.53,502.645Z",
    transform: "translate(-337.415 -494.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M471.2,500.38l-.183-.047a2.933,2.933,0,0,0-.758-.095,4.348,4.348,0,0,0-3.822,2.454l-.09-2.134h-2.735l.018.257c.081,1.207.115,2.561.115,4.39l-.029,9.958h3.049v-7.769a7.964,7.964,0,0,1,.084-1.181,3.37,3.37,0,0,1,3.207-3.072,7.781,7.781,0,0,1,.818.051l.326.034Z",
    transform: "translate(-371.626 -494.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M494.166,500.148c-4.058,0-6.893,3.242-6.893,7.884,0,4.471,2.82,7.36,7.184,7.36a11.694,11.694,0,0,0,4.826-.926l.183-.083-.585-2.271-.255.1a9.446,9.446,0,0,1-3.819.683,4.238,4.238,0,0,1-4.565-4.419l9.839.029.039-.195a6.747,6.747,0,0,0,.092-1.272C500.212,503.862,498.629,500.148,494.166,500.148Zm-.2,2.319a3.006,3.006,0,0,1,2.238.854,4.334,4.334,0,0,1,1.049,2.837H490.3C490.581,504.4,491.682,502.467,493.962,502.467Z",
    transform: "translate(-387.735 -494.633)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.36e64cd40c25b593b64de3e645b0ccab.svg";
export { ForwardRef as ReactComponent };